/**
 * Two Boxes — frontend behaviour.
 *
 * Loaded as a native ES module ONLY on pages where this block renders. The
 * first import pulls in this section's CSS so the whole section ships as one
 * isolated bundle.
 */
import './style.scss';
import { gsap } from 'gsap';

function init() {
	const sections = document.querySelectorAll('[data-two-boxes]');
	if (!sections.length) return;

	const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

	sections.forEach((section) => {
		const targets = section.querySelectorAll('[data-two-boxes-card]');
		if (!targets.length) return;

		if (reduced) {
			targets.forEach((el) => { el.style.opacity = '1'; el.style.transform = 'none'; });
			return;
		}

		gsap.set(targets, { opacity: 0, y: 24, filter: 'blur(10px)' });

		const io = new IntersectionObserver((entries) => {
			entries.forEach((entry) => {
				if (!entry.isIntersecting) return;
				io.unobserve(entry.target);
				// clearProps:'transform' so GSAP's leftover inline transform
				// doesn't pin the cards and break the CSS :hover lift.
				gsap.to(targets, {
					opacity: 1, y: 0, filter: 'blur(0px)',
					duration: 0.8, ease: 'power3.out', stagger: 0.12,
					clearProps: 'transform',
				});
			});
		}, { rootMargin: '0px 0px -15% 0px', threshold: 0.1 });

		io.observe(section);
	});
}

if (document.readyState !== 'loading') init();
else document.addEventListener('DOMContentLoaded', init);
